import React from 'react';
import { ProductShowcase } from './components/ProductShowcase';
export function App() {
  return <div className="min-h-screen bg-transparent flex items-center justify-center p-8 font-sans" data-id="element-0">
      <div className="w-full max-w-[1400px] mx-auto" data-id="element-1">
        <ProductShowcase data-id="element-2" />
      </div>
    </div>;
}